import { handleActions } from 'redux-actions';
import actions from '../actions';

const { update } = actions.channel;

const defaultState = {};

export default handleActions(
  {
    [update]: (state, { payload }) => payload,
  },
  defaultState
);



// WEBPACK FOOTER //
// ./src/reducers/channel.js